// extracted by mini-css-extract-plugin
export default {"button":"zp-z","reviewSort":"Ap-z"};